module.exports = __webpack_public_path__ + "static/media/Arrow-Right 2.c6b1b6e7.svg";